import { Registry } from '../registry';
import * as anchors from './main';
export var NodeConnectionAnchor;
(function (NodeConnectionAnchor) {
    NodeConnectionAnchor.presets = anchors;
    NodeConnectionAnchor.registry = Registry.create({
        type: 'node anchor',
    });
    NodeConnectionAnchor.registry.register(NodeConnectionAnchor.presets, true);
})(NodeConnectionAnchor || (NodeConnectionAnchor = {}));
//# sourceMappingURL=index.js.map